import { Button, DialogTrigger } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

export interface BackSubmitButtonsProps {
    onBack: () => void;
    onSubmit: () => void;
    submitLabel: string;
    submitDisabled?: boolean;
    closeDialogOnSubmit?: boolean;
}

export const BackSubmitButtons: React.FC<BackSubmitButtonsProps> = ({
    onBack,
    onSubmit,
    submitLabel,
    submitDisabled = false,
    closeDialogOnSubmit = true,
}) => {
    const { t } = useTranslation();

    const submitButton = (
        <Button
            appearance="primary"
            disabled={submitDisabled}
            onClick={onSubmit}
        >
            {submitLabel}
        </Button>
    );

    return (
        <>
            <Button appearance={'subtle'} onClick={onBack}>
                {t('Back')}
            </Button>
            {closeDialogOnSubmit ? (
                <DialogTrigger action="close" disableButtonEnhancement>
                    {submitButton}
                </DialogTrigger>
            ) : (
                submitButton
            )}
        </>
    );
};
